import { PastaCrudApi, useClassFactory } from "@pasta/box-v2";
import { subject } from "@casl/ability";
import { type LetterFileTagDto } from "../app/dto/letter-file-tag.dto";

export class AdminTagsApi extends PastaCrudApi<{
  Entity: LetterFileTagDto;
}> {
  protected readonly baseEndpoint = "letter-file-tag/";

  map(entity: LetterFileTagDto) {
    return subject("LetterFileTag", entity);
  }
}

export const [adminTagsApiToken, useAdminTagsApi] = useClassFactory(AdminTagsApi);
